import { type FC, useEffect, useRef } from 'react'
import { getIncodeClient } from '@egw/risk-service'
import { Logger } from '@egw/logger'

const log = new Logger('DocV')

interface SelfieProps {
  session: { token: string }
  onSuccess: (result: any) => void
  onError?: (error: any) => void
}

export const Selfie: FC<SelfieProps> = ({ session, onSuccess, onError }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isMounted = useRef(false)

  useEffect(() => {
    if (isMounted.current || !session || !containerRef.current) {
      return
    }

    log.info('Selfie: Starting camera render')

    getIncodeClient().renderCamera('selfie', containerRef.current, {
      onSuccess,
      onError: (error) => {
        log.error('Selfie: Error during camera rendering', error)
        if (onError) {
          onError(error)
        }
      },
      token: session,
      numberOfTries: 3,
      showTutorial: true,
      showCustomCameraPermissionScreen: true,
      showDoublePermissionsRequest: true,
      fullScreen: false,
    })
    isMounted.current = true
  }, [onSuccess, onError, session])

  return <div ref={containerRef} />
}
